import bannerCyber1 from '../img/2025/cyber/segundoquarteto/quarteto1.png';
import bannerCyber2 from '../img/2025/cyber/segundoquarteto/quarteto2.png';
import bannerCyber3 from '../img/2025/cyber/segundoquarteto/quarteto3.png';
import bannerCyber4 from '../img/2025/cyber/segundoquarteto/quarteto4.png';
import { ImgBanner } from "./banner";

function BannersCyber() {
  /* const bannerinternacionalCyber = 'https://blackfriday.futfanatics.com.br/img/banner/bannerscyber/internacional.png';
  const bannerCyber1 = 'https://blackfriday.futfanatics.com.br/img/banner/bannerscyber/nacional.png';
  const bannerSelecao = 'https://blackfriday.futfanatics.com.br/img/banner/bannerscyber/selecao.png';
  const bannerlicenciados = 'https://blackfriday.futfanatics.com.br/img/banner/bannerscyber/licenciados.png'; */
  return (
    <>
      <div className="box-banner col-md-3">
      <a href='https://www.futfanatics.com.br/loja/busca.php?loja=311840&marca=marca_puma&range=&order=0'>
          <ImgBanner src={bannerCyber1}></ImgBanner>
        </a>
      </div>
      <div className="box-banner col-md-3">
      <a href='https://www.futfanatics.com.br/clubes-brasileiros?loja=311840&categoria=11&variacao=tipo-de-produto_camisa&range=&order=4'>
          <ImgBanner src={bannerCyber2}></ImgBanner>
        </a>
      </div>
      <div className="box-banner col-md-3">
      <a href='https://www.futfanatics.com.br/calcados/corrida/?&order=3'>
          <ImgBanner src={bannerCyber3}></ImgBanner>
        </a>
      </div>
      <div className="box-banner col-md-3">
      <a href='https://www.futfanatics.com.br/esportes'>
          <ImgBanner src={bannerCyber4}></ImgBanner>
        </a>
      </div>
    </>
  );
}
export default BannersCyber;
